const table       = [];
const teams       = {};
// const spreadsheet = '19B_YLFj8QoZsXlyuvpsgw8HclT4pxYFwUD06M_M9v80';

[ 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h' ].forEach( ( item ) => {
  table.push( {
    group: item,
    teams: [ null, null, null, null ],
  } );
} );

function slugify( text ) {
  return text;
}

function loadJSON( url, callback ) {
  const request = new XMLHttpRequest();

  request.open( 'GET', url, true );

  request.onload = function () {
    if ( this.status >= 200 && this.status < 400 ) {
      // Success!
      const data = JSON.parse( this.response );

      callback( data );
    } else {
      // We reached our target server, but it returned an error
    }
  };

  request.onerror = function () {
    // There was a connection error of some sort
  };

  request.send();
}

function parseTeams( data ) {
  data.feed.entry.forEach( ( entry ) => {
    // teams.push( {
    //   name: entry.gsx$time.$t,
    //   abbr: entry.gsx$sigla.$t,
    //   cups: entry.gsx$participacoes.$t,
    //   wins: entry.gsx$titulos.$t,
    // } );

    teams[ entry.gsx$time.$t ] = {
      name: entry.gsx$time.$t,
      abbr: entry.gsx$sigla.$t,
      cups: entry.gsx$participacoes.$t,
      wins: entry.gsx$titulos.$t,
    };
  } );

  // loadJSON( `https://spreadsheets.google.com/feeds/list/${spreadsheet}/1/public/values?alt=json`, parseGroups );
  loadJSON( `http://infograficos.estadao.com.br/public/esportes/copa/2018/sorteio/data/json/grupos.json?v=${Date.now()}`, parseGroups );
}

function parseGroups( data ) {
  data.feed.entry.forEach( ( entry, index ) => {
    for ( let j = 0; j < table.length; j++ ) {
      if ( entry[ `gsx$grupo${table[j].group}` ].$t ) {
        table[j].teams[ index ] = entry[ `gsx$grupo${table[j].group}` ].$t;
      }
    }
  } );

  table.forEach( ( group ) => {
    group.teams.forEach( ( team, index ) => {
      if ( team ) {
        document.querySelector( `.team-${group.group}${index + 1}` ).classList.remove( 'not-drawn' );
        document.querySelector( `.team-${group.group}${index + 1}` ).classList.add( `team-${teams[ team ].abbr}`.toLowerCase() );
        document.querySelector( `.team-${group.group}${index + 1} .team-name` ).title = team;
        document.querySelector( `.team-${group.group}${index + 1} .team-abbr` ).title = team;
        document.querySelector( `.team-${group.group}${index + 1} .team-abbr` ).innerText = teams[ team ].abbr;
        document.querySelector( `.team-${group.group}${index + 1} .team-name` ).innerText = team;
      }
    } );
  } );
}

// function update() {
//   loadJSON( `https://spreadsheets.google.com/feeds/list/${spreadsheet}/7/public/values?alt=json`, parseTeams );
// };

( function () {
  const interval = 30;
  let frame = 0;

  function update() {
    if ( frame % ( 60 * interval ) === 0 ) {
      // console.log( 'tick' );
      // loadJSON( `https://spreadsheets.google.com/feeds/list/${spreadsheet}/7/public/values?alt=json`, parseTeams );
      loadJSON( `http://infograficos.estadao.com.br/public/esportes/copa/2018/sorteio/data/json/selecoes.json?v=${Date.now()}`, parseTeams );
    }

    frame++;

    if ( frame >= 60 * interval ) {
      frame = 0;
    }

    // console.log( frame );

    requestAnimationFrame( update );
  }

  requestAnimationFrame( update );
} )();
